export default "__VITE_ASSET__DRz9oI2L__"